"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const common_1 = tslib_1.__importDefault(require("../assets/scripts/common"));
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const enum_1 = require("../assets/scripts/enum");
const __sfc_main = {};
__sfc_main.props = {
    actSign: {
        key: "actSign",
        required: true,
        type: String
    },
    module: {
        key: "module",
        required: true,
        type: String
    },
    isSendParam: {
        key: "isSendParam",
        required: true,
        type: String
    },
    shouldSendParam: {
        key: "shouldSendParam",
        required: true,
        type: String
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { uid, jumpLogin, openDialog, updateFegoVariable } = (0, common_1.default)();
    const props = __props;
    const status = (0, vue_demi_1.reactive)({
        isSend: false,
        shouldSend: false,
        couponStatusList: {},
        taskStatusList: {}
    });
    (0, vue_demi_1.watch)(() => status, newStatus => {
        updateFegoVariable(props.isSendParam, newStatus.isSend ? '1' : '0');
        updateFegoVariable(props.shouldSendParam, newStatus.shouldSend ? '1' : '0');
        Object.entries(newStatus.couponStatusList).forEach(([key, value]) => {
            updateFegoVariable(key, value);
        });
        Object.entries(newStatus.taskStatusList).forEach(([key, value]) => {
            updateFegoVariable(key, value);
        });
    }, {
        deep: true,
        immediate: false
    });
    const emit = __ctx.emit;
    /**
     * 请求发奖状态
     * @param { boolean } updateIsSend 是否更新isSend，发奖成功后直接更新为true，查询结果可能存在延迟，不取用
     */
    async function requestStatus(updateIsSend) {
        const { isSend, shouldSend, couponStatusList, taskStatusList, pageEventStatus } = await request_1.default.status({
            moduleData: JSON.stringify({
                sign: props.actSign,
                module: props.module
            })
        });
        status.shouldSend = shouldSend;
        updateIsSend && (status.isSend = isSend);
        couponStatusList && (status.couponStatusList = couponStatusList);
        taskStatusList && (status.taskStatusList = taskStatusList);
        handlePageEventStatus(pageEventStatus);
    }
    function handlePageEventStatus(pageEventStatus) {
        function emitEvent(event) {
            const key = `common-send-prize-${props.actSign}-${props.module}-${uid}-${event}`;
            if (localStorage.getItem(key)) {
                return;
            }
            localStorage.setItem(key, 'true');
            emit(event);
        }
        if (pageEventStatus.isAllTaskCompleted) {
            emitEvent(enum_1.BEHAVIOR_EVENT.TASK_COMPLETED);
        }
        if (pageEventStatus.isAllTaskExpired) {
            emitEvent(enum_1.BEHAVIOR_EVENT.TASK_EXPIRED);
        }
    }
    /**
     * 请求发奖
     */
    let isSending = false;
    async function requestSendPrize() {
        if (isSending) {
            return;
        }
        isSending = true;
        try {
            const { success } = await request_1.default.sendPrize({
                moduleData: JSON.stringify({
                    sign: props.actSign,
                    module: props.module
                })
            });
            if (success) {
                status.isSend = true;
                setTimeout(() => {
                    requestStatus(false);
                }, 500);
                (0, vue_demi_1.nextTick)(() => {
                    emit(enum_1.BEHAVIOR_EVENT.SEND_PRIZE_SUCCESS);
                });
            }
            else {
                (0, vue_demi_1.nextTick)(() => {
                    emit(enum_1.BEHAVIOR_EVENT.SEND_PRIZE_FAIL);
                });
            }
        }
        finally {
            isSending = false;
        }
    }
    /**
     * 发奖
     */
    async function doSendPrize() {
        if (!uid) {
            jumpLogin();
        }
        if (status.isSend || !status.shouldSend) {
            return;
        }
        requestSendPrize();
    }
    (0, vue_demi_1.onMounted)(() => {
        if (uid) {
            requestStatus(true);
        }
    });
    return Object.assign({}, {
        doSendPrize
    });
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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